import { SwitchBizsolIdMutation } from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

export const switchBizsolIDHandler = graphql.mutation<SwitchBizsolIdMutation>(
  "switchBizsolID",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        switchBizsolID: {},
      },
      errors: [
        {
          extensions: {
            code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
          },
        },
        // {
        //   extensions: {
        //     code:
        //       ErrorCode[ErrorCode.BIZSOL_REQUEST_FAILED] +
        //       ": service time is over. [210]",
        //   },
        // },
      ],
    });
  }
);
